import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/app/tablet/")({
  beforeLoad: async () => {
    // TEMPORARY DISABLED FOR TESTING PURPOSES
    // const store = useCurrentUserStore.getState()
    // const user = await store.getCurrentUser()

    // const shouldRedirectToApp = !user?.permissions?.includes(PermissionActionType.WAREHOUSE_TABLET_ONLY)

    // if (shouldRedirectToApp) {
    //   throw redirect({ to: "/app" })
    // }

    throw redirect({ to: "/app/tablet/warehouse-receiving/incoming" })
  },
})
